import {createSelector} from '@reduxjs/toolkit';
import {selectAccounts} from './accounts';
import {selectAccountSources} from './accountSources';
import {selectProjects} from './projects';
import {selectCompanies} from './companies';

export const selectAccountsSorted = createSelector(
    selectAccounts,
    selectAccountSources,
    (accounts, sources) => {
        const nameById = Object.fromEntries(sources.map(s => [s.id, s.name]));
        return [...accounts].sort((a, b) =>
            (nameById[a.sourceId] ?? '').localeCompare(nameById[b.sourceId] ?? '') ||
            a.title.localeCompare(b.title)
        );
    }
);

export const selectProjectsSorted = createSelector(
    selectProjects,
    selectCompanies,
    (projects, companies) => {
        const nameById = Object.fromEntries(companies.map(c => [c.id, c.name]));
        return [...projects].sort((a, b) =>
            (nameById[a.companyId] ?? '').localeCompare(nameById[b.companyId] ?? '') ||
            a.title.localeCompare(b.title)
        );
    }
);